import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { PopupState } from './types';

const initialState: PopupState = {
  activeDate: JSON.parse(localStorage.getItem('activeDate') || '0'),
  activeCallType: JSON.parse(localStorage.getItem('activeCallType') || '0'),
  activeLimitCalls: 0,
  activeTimeSort: JSON.parse(localStorage.getItem('activeTimeSort') || 'false'),
  activeDurationSort: localStorage.getItem('activeDurationSort') || '',
  activeDuration: JSON.parse(localStorage.getItem('activeDuration') || '0'),
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    setActiveDate: (state, action: PayloadAction<number>) => {
      state.activeDate = action.payload;
      localStorage.setItem('activeDate', String(action.payload));
    },
    setActiveCallType: (state, action: PayloadAction<number>) => {
      state.activeCallType = action.payload;
      localStorage.setItem('activeCallType', String(action.payload));
    },
    setActiveLimitCalls: (state, action: PayloadAction<number>) => {
      state.activeLimitCalls = action.payload;
    },
    setActiveTimeSort: (state, action: PayloadAction<boolean>) => {
      state.activeTimeSort = action.payload;
      localStorage.setItem('activeTimeSort', String(action.payload));
    },
    setActiveDurationSort: (state, action: PayloadAction<string>) => {
      state.activeDurationSort = action.payload;
      localStorage.setItem('activeDurationSort', action.payload);
    },
    setActiveDuration: (state, action: PayloadAction<number>) => {
      state.activeDuration = action.payload;
      localStorage.setItem('activeDuration', String(action.payload));
    },
  },
});

export const {
  setActiveDate,
  setActiveCallType,
  setActiveLimitCalls,
  setActiveTimeSort,
  setActiveDuration,
  setActiveDurationSort,
} = popupSlice.actions;

export default popupSlice.reducer;
